module.exports = require('../../es/object/assign');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/object/assign.js
// module id = 555
// module chunks = 0